<!-- @format -->
<div class="hmf-mt-l hmf-mt-m-xl">
	<div
		class="review-label hmf-body-m"
		data-testid="label-reviewCount"
		[ngClass]="{ 'hmf-display-none hmf-display-lg-block': isLoading }">
		<ng-container *skeletonLoader="isLoading; type: skeletonShape.MEDIUM_TEXT">
			{{ reviewCount }}{{ isResultFromSearch ? ' matching' : '' }} reviews
		</ng-container>
	</div>
</div>
<div
	class="review-drawer-list hmf-display-flex hmf-flex-column hmf-align-self-start hmf-mt-l hmf-mt-m-xl">
	<div
		*ngFor="let review of reviewList; let i = index; trackBy: trackByReview"
		class="review-drawer-card hmf-display-flex hmf-flex-column hmf-flex-m-row hmf-pb-m"
		[attr.id]="'item_' + review?.CID ?? i">
		<!-- 1st row -->
		<div
			class="user-info hmf-mr-0 hmf-mr-l-xl hmf-mr-m-xl hmf-mr-xl-xxl hmf-mt-m-0 hmf-display-flex hmf-justify-content-between hmf-justify-content-lg-start hmf-flex-lg-column hmf-align-items-center hmf-align-items-lg-flex-start">
			<div
				class="review-username hmf-body-s hmf-body-md-m hmf-text-transform-capitalize hmf-align-self-start"
				[ngClass]="{ 'hmf-mb-xxs hmf-display-none hmf-display-lg-block': isLoading }">
				<ng-container *skeletonLoader="isLoading; type: skeletonShape.LONG_TEXT">
					{{ review.UserNickname | titlecase }} <!-- titlecase is needed because hmf-body-* classes currently override text-transform, see https://dcsgcloud.atlassian.net/browse/HMF-570 -->
				</ng-container>
			</div>

			<div [ngClass]="{ 'hmf-display-none hmf-display-lg-block': isLoading }">
				<ng-container *skeletonLoader="isLoading; type: skeletonShape.SMALL_PARAGRAPH">
				</ng-container>
			</div>

			<div
				class="hmf-header-bold-s hmf-display-none hmf-display-lg-block"
				[ngClass]="isLoading ? 'hmf-mt-s' : 'hmf-mt-xs'">
				<ng-container *skeletonLoader="isLoading; type: skeletonShape.EXPANSIVE_TEXT">
					{{ review.Title }}
				</ng-container>
			</div>

			<div
				class="hmf-display-none hmf-display-lg-block"
				[ngClass]="isLoading ? 'hmf-mt-xxs' : 'hmf-mt-xs'">
				<product-reviews-review-features
					*skeletonLoader="isLoading; type: skeletonShape.LARGE_TEXT"
					[review]="review"></product-reviews-review-features>
			</div>

			@if (!isLoading) {
				<div class="hmf-display-none hmf-display-lg-block">
					<product-reviews-secondary-rating-container
						[secondaryRatings]="review.SecondaryRatings"
						[secondaryRatingsOrder]="review.SecondaryRatingsOrder">
					</product-reviews-secondary-rating-container>
				</div>
			}

			<div
				[ngClass]="{
					'hmf-mb-xs hmf-display-none hmf-display-lg-block': isLoading,
					'hmf-display-none': !isLoading && !review.BadgesOrder?.length,
					'hmf-display-flex hmf-flex-column hmf-flex-lg-row hmf-align-items-flex-end hmf-align-items-lg-stretch hmf-mt-lg-xxs':
						!isLoading && !!review.BadgesOrder?.length
				}">
				@for (
					badge of review.BadgesOrder;
					track trackByBadge($index, badge);
					let badgeIndex = $index
				) {
					<product-reviews-review-badges
						*skeletonLoader="isLoading; type: skeletonShape.COMPACT_TEXT"
						[ngClass]="{
							'hmf-mr-lg-s': !badgeIndex,
							'hmf-mt-xxxs hmf-mt-lg-0': badgeIndex
						}"
						[badgeType]="badge"></product-reviews-review-badges>
				}
			</div>
		</div>

		<div class="user-rating">
			<!-- 2nd row -->
			<div
				class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-justify-content-between hmf-mt-m-0"
				[ngClass]="isLoading ? 'hmf-mb-xxs' : 'hmf-my-xxs'">
				<product-reviews-review-stars
					*skeletonLoader="isLoading; type: skeletonShape.MEDIUM_TEXT"
					class="hmf-display-inline-flex"
					[rating]="review.Rating"
					[options]="starsOptions"></product-reviews-review-stars>

				<div
					*skeletonLoader="isLoading; type: skeletonShape.MEDIUM_TEXT"
					class="review-label hmf-body-s hmf-body-m-m hmf-ml-xxs">
					{{ review.SubmissionTime | dateAgo }}
				</div>
			</div>

			<div [ngClass]="{ 'hmf-display-lg-none': isLoading }">
				<div
					class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-justify-content-between hmf-my-0 hmf-mt-m-0 hmf-mb-xxs">
					<ng-container
						*skeletonLoader="isLoading; type: skeletonShape.SMALL_TEXT"></ng-container>
					<div
						*skeletonLoader="isLoading; type: skeletonShape.SMALL_TEXT"
						class="review-label hmf-body-s hmf-body-m-m hmf-ml-xxs"></div>
				</div>
			</div>

			<div [ngClass]="{ 'hmf-mb-xs hmf-display-lg-none': isLoading }">
				<ng-container *skeletonLoader="isLoading; type: skeletonShape.WIDE_PARAGRAPH">
				</ng-container>
			</div>

			<div [ngClass]="{ 'hmf-mb-s hmf-display-none hmf-display-lg-block': isLoading }">
				<ng-container *skeletonLoader="isLoading; type: skeletonShape.EXPANSIVE_TEXT">
				</ng-container>
			</div>

			<!-- 3rd row -->
			<div *ngIf="!isLoading">
				<div class="hmf-subheader-bold-m hmf-mt-xxs hmf-mt-m-xs hmf-display-lg-none">
					{{ review.Title }}
				</div>
				<div class="hmf-mt-xxs hmf-my-m-xs hmf-display-lg-none">
					<product-reviews-review-features
						[review]="review"></product-reviews-review-features>
				</div>
			</div>

			<!-- 4th row -->
			<div>
				<div *ngIf="!!review?.TagDimensions?.Pro?.Values && !isLoading">
					<p
						[highlightKeyword]="selectedTag"
						class="review-label hmf-body-s hmf-body-m">
						{{ review.TagDimensions.Pro.Values | splitContentPipe }}
					</p>
				</div>
				<div [ngClass]="{ 'hmf-mb-xs': isLoading }">
					<div [ngClass]="{ 'hmf-mb-xs hmf-display-lg-none': isLoading }">
						<ng-container *skeletonLoader="isLoading; repeat: 4"></ng-container>
					</div>

					<div
						[ngClass]="{ 'hmf-mb-s hmf-display-none hmf-display-lg-block': isLoading }">
						<ng-container *skeletonLoader="isLoading; repeat: 2"></ng-container>
					</div>

					<product-reviews-review-text
						*ngIf="!isLoading"
						[highlightedWord]="searchFilter"
						[review]="review"></product-reviews-review-text>
				</div>
			</div>

			<!-- 5th row -->
			<product-reviews-review-features
				*ngIf="!isLoading"
				[review]="review"
				[filterByUsedFor]="true"></product-reviews-review-features>

			<!-- 6th row -->
			<div [ngClass]="{ 'hmf-mb-xs hmf-display-lg-none': isLoading }">
				<ng-container *skeletonLoader="isLoading; type: skeletonShape.WIDE_TEXT">
				</ng-container>
			</div>

			<div [ngClass]="{ 'hmf-mb-s hmf-display-none hmf-display-lg-block': isLoading }">
				<ng-container *skeletonLoader="isLoading; type: skeletonShape.SPACIOUS_TEXT">
				</ng-container>
			</div>

			<div
				*ngIf="review?.IsRecommended && !isLoading"
				class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-mt-xs hmf-mb-xs">
				<homefield-icon
					width="16px"
					height="16px"
					name="sign-circled-check"
					class="hmf-mr-xxs"></homefield-icon>
				<div class="review-label hmf-body-s hmf-body-m-m">
					Yes, I recommend this product.
				</div>
			</div>

			<!-- 7th row -->
			<div
				*ngIf="review?.Media?.length && !isLoading"
				class="hmf-mt-xs hmf-mt-m-s hmf-mb-s hmf-mb-m-xs">
				<product-reviews-review-slider [selector]="'review-images-' + review?.Id ?? '' + i">
					<ul
						class="carousel-content hmf-display-flex hmf-p-0 hmf-m-0"
						carouselContent>
						<li
							*ngFor="
								let media of review.Media;
								let item = index;
								trackBy: trackByMedia
							"
							class="hmf-display-flex hmf-align-items-center hmf-justify-content-center">
							<product-reviews-review-media
								[media]="media"
								[imageId]="item"
								[mediaSource]="mediaSource"
								(selectedMedia)="handleReview($event)">
							</product-reviews-review-media>
						</li>
					</ul>
				</product-reviews-review-slider>
			</div>

			@if (!isLoading) {
				<div class="hmf-display-lg-none">
					<product-reviews-secondary-rating-container
						[secondaryRatings]="review.SecondaryRatings"
						[secondaryRatingsOrder]="review.SecondaryRatingsOrder">
					</product-reviews-secondary-rating-container>
				</div>
			}

			<!-- 8th row -->
			<product-reviews-helpful
				[isLoading]="isLoading"
				[review]="review"></product-reviews-helpful>
		</div>
	</div>
</div>

<product-reviews-modal></product-reviews-modal>
